
import { useShallow } from 'zustand/react/shallow';
import { useParameterStore } from '../store/ParameterStore';
import { Container } from '@/backend/models/containers/container';
import { CONTEXT_LOG_SUBJECT_TYPES } from '@/types/contextLogTypes';
import { Status } from '@/types/containerTypes';

export const statusClass = {
  [Status.PENDING]: '',
  [Status.PASSED]: 'bg-success-subtle',
  [Status.FAILED]: 'bg-danger-subtle',
  [Status.ABORTED]: 'bg-warning-subtle',
  [Status.DEVIATED]: 'bg-warning-subtle',
};

export function useStepStatusColor(container?: Container) {
  const contextLogs = useParameterStore(useShallow(state => state.contextLogs.filter((log) => log.subjectId === container?.id && log.subjectType === CONTEXT_LOG_SUBJECT_TYPES.STEP)));
  if (!container) {
    return '';
  }
  if (container.status === Status.PASSED && contextLogs.length > 0) {
    return 'bg-overridden';
  }
  return statusClass[container.status];
}
